import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
    // moduleId: module.id,
    selector: 'halfpopup',
    templateUrl: 'halfpopup.component.html'
})
export class HalfPopupComponent implements OnInit {

    @Input() header: string;

    @Output() cancel = new EventEmitter();

    close($event) {
        this.cancel.emit({});
    }

    constructor() { }

    ngOnInit() { }
}